import { render, staticRenderFns } from "./FamilyInfoWidget.vue?vue&type=template&id=f77c9e32&scoped=true"
import script from "./FamilyInfoWidget.vue?vue&type=script&lang=js"
export * from "./FamilyInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./FamilyInfoWidget.vue?vue&type=style&index=0&id=f77c9e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c9e32",
  null
  
)

/* custom blocks */
import block0 from "./FamilyInfoWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports